var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.condition)?_c('v-icon',{attrs:{"color":_vm.successColor}},[_vm._v(_vm._s(_vm.successIcon))]):_c('v-icon',{attrs:{"color":_vm.fallbackColor}},[_vm._v(_vm._s(_vm.fallbackIcon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }